export default __webpack_public_path__ + "static/0033-d6942b41729f65c623141112ff4ba3b4.png";